import { drag } from '../directives';
import Resize from './Resize';

export default {
    name: "SelectedMark",
    directives: { drag },
    props: {
        color: {
            type: String,
            default: "rgba(24,144,255, 0.2)"
        },
        mark: {
            type: Object,
            required: true
        },
        layoutMan: {
            type: Object,
            required: true
        }
    },
    render(h) {
        const _positionInfo = this.mark.GetPositionInfo();
        const _boundary = this.mark.GetBoundary();

        if (!_boundary) {
            return null;
        }
        
        return (
            <div class="layout-mask-selected-mark"
                key={this.mark.ID}
                v-drag={this.layoutMan}
                style={{
                    backgroundColor: this.color,
                    left: _boundary.Left + 'px',
                    top: _boundary.Top + 'px',
                    width: _boundary.Width + 'px',
                    height: _boundary.Height + 'px'
                }}>
                <Resize props={{ mark: this.mark, layoutMan: this.layoutMan }} />
            </div>
        );
    }
};